// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__25-W8","containerItemsCenter":"Skeleton_containerItemsCenter__2BNWA"};